import { useMemo, useCallback, useEffect, useRef } from 'react';
import { ENTITIES } from "../../../../../lib/constants";
import { ADVANCED_IMPORT_IDENTIFIERS } from "../../../constants";
const useImportType = _ref => {
  let {
    data,
    entityName,
    logEvent,
    entityLogName,
    matchBy,
    getFieldsList,
    onChangeAdvancedType,
    onChangeMatchBy,
    onChange,
    onComplete,
    advancedType,
    currentStep
  } = _ref;
  const importTypeRef = useRef('');
  useEffect(() => {
    if (data.idType !== 'others' || data.fields) return;
    const entityConst = Object.values(ENTITIES).find(el => el.importExport === entityName);
    const entity = entityConst ? entityConst.fields : entityName;
    getFieldsList(entity);
  }, [data.fields, data.idType, entityName, getFieldsList]);
  const onChangeImportType = useCallback(importType => {
    if (importType !== importType.current) {
      onChangeAdvancedType(null);
      onChangeMatchBy('');
    }
    const idType = importType === 'update' ? 'id' : null;
    const syncNames = importType === 'update' ? ['id'] : [];
    const matchMandatoryExtra = importType === 'create';
    const matchMandatoryStandard = importType === 'create';
    const matchMandatory = importType === 'update';
    importTypeRef.current = importType;
    onChange({
      importType,
      idType,
      syncNames,
      matchMandatoryExtra,
      matchMandatoryStandard,
      matchMandatory
    });
  }, [onChange, onChangeMatchBy, onChangeAdvancedType]);
  const onChangeIdType = useCallback(idType => {
    if (data.idType === 'others' && !data.fields) {
      const entityConst = Object.values(ENTITIES).find(el => el.importExport === entityName);
      const entity = entityConst ? entityConst.fields : entityName;
      getFieldsList(entity);
    }
    const syncNames = idType === 'others' ? ['ExtID'] : ['id'];
    return onChange({
      idType: data.importType === 'create' ? null : idType,
      syncNames
    });
  }, [data.fields, data.idType, data.importType, entityName, getFieldsList, onChange]);
  const onChangeSyncNames = useCallback(syncNames => onChange({
    syncNames: data.importType === 'create' ? [] : syncNames.map(el => el === null || el === void 0 ? void 0 : el.value)
  }), [onChange, data.importType]);
  const onContinue = useCallback(() => {
    logEvent({
      event: entityLogName,
      submodule: entityName,
      functionality: data.importType === 'create' ? 'importCreateStart' : 'importUpdateStart'
    });
    const identifierMapped = {
      name: 'matchByName',
      id: 'matchByFmId',
      extId: 'matchByExtId'
    };
    if (identifierMapped[matchBy]) {
      logEvent({
        event: 'import',
        functionality: identifierMapped[matchBy]
      });
    }
    onComplete({});
  }, [entityLogName, entityName, logEvent, onComplete, data, matchBy]);
  const syncNamesList = useMemo(() => {
    if (data.idType === 'others' && data.syncNames.length && data.fields) {
      return data.syncNames.map(key => data.fields.find(el => el.value === key));
    } else if (data.idType === 'id') {
      return [{
        value: 'id'
      }];
    }
  }, [data.fields, data.idType, data.syncNames]);
  const onClickIsAdvanced = useCallback((bool, newAdvancedType) => {
    onChangeAdvancedType(bool ? newAdvancedType : null);
    if (!bool) onChangeMatchBy('');else onChangeMatchBy(ADVANCED_IMPORT_IDENTIFIERS.name);
  }, [onChangeMatchBy, onChangeAdvancedType]);
  const onClickIdentifier = useCallback(identifier => {
    onChangeMatchBy(identifier || '');
  }, [onChangeMatchBy]);
  const disableNext = useMemo(() => {
    var _data$syncNames;
    return !data.importType || data.importType && advancedType && !matchBy || data.importType === 'update' && data.idType === 'others' && !((_data$syncNames = data.syncNames) !== null && _data$syncNames !== void 0 && _data$syncNames.reduce((acc, el) => acc || !!el, false));
  }, [data.importType, data.idType, data.syncNames, advancedType, matchBy]);
  const importTypeProps = useMemo(() => ({
    onChangeImportType,
    onChangeIdType,
    onChangeSyncNames,
    syncNamesList,
    onClickIsAdvanced,
    onClickIdentifier
  }), [onChangeImportType, onChangeIdType, onChangeSyncNames, syncNamesList, onClickIsAdvanced, onClickIdentifier]);
  const importTypeFooterProps = useMemo(() => ({
    onConfirm: onContinue,
    isConfirmDisabled: disableNext
  }), [onContinue, disableNext]);
  if (currentStep !== 0) return {};
  return {
    importTypeProps,
    importTypeFooterProps
  };
};
export default useImportType;